import { EventEmitter, Component, Output, Input, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { AbstractControl, ValidationErrors, Validators, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IStockFolder, IxellAPIService } from 'src/app/tools/api.service';
import { FileCreateModalResult, GroupedLocale } from '../cloud/cloud.component';
import { checkForExtension, CLOUD_MAX_FILE_SIZE, MIN_COUNTRY_MODE } from '../utils/utils';


@Component({
    selector: 'cloud-create-modal',
    templateUrl: './create-modal.component.html',
    styleUrls: ['./create-modal.component.scss']
})

export class CloudCreateModalComponent {
    CLOUD_MAX_FILE_SIZE = CLOUD_MAX_FILE_SIZE;
    MIN_COUNTRY_MODE = MIN_COUNTRY_MODE;

    @Input() folder: IStockFolder;
    @Input() possibleLocales: { [key: number]: GroupedLocale };
    @Input() uploadProgress: number;
    @Input() selectedCountry: number;
    @Input() selectedLanguage: number;
    @Output() close = new EventEmitter<void>();
    @Output() save = new EventEmitter<FileCreateModalResult>();
    @Output() reset = new EventEmitter<void>();

    @ViewChildren('fileInputList') fileInputList!: QueryList<ElementRef<HTMLInputElement>>[];

    language: string;

    private readonly fileValidator = (idx: number) => async (control: AbstractControl): Promise<ValidationErrors | null> => {
        //console.log("validator = fileValidator ; idx : " + idx);
        //console.log("this.selectedFiles[idx]", this.selectedFiles[idx]);

        //if (idx == 1 && !this.selectedFiles[idx])
        //    console.log("idx == 1 && !this.selectedFiles[idx]");

        if (!this.selectedFiles[idx])
            return null;

        if (this.selectedFiles[idx].size > CLOUD_MAX_FILE_SIZE)
            return { fileTooBig: true };

        if (!await checkForExtension(this.selectedFiles[idx], this.folder.extensions))
            return { invalidExtension: true };

        return null;
    };

    readonly selectedCountries = [75, 75];
    readonly selectedLanguages = [1, 2];
    readonly selectedFiles: File[] = [null, null];
    readonly selectedFilenames = [new FormControl<string>('', [Validators.required], [this.fileValidator(0)]), new FormControl<string>('', /*[Validators.required],*/ [this.fileValidator(1)])];
    readonly chosenTitles = [new FormControl<string>('', [Validators.required]), new FormControl<string>(''/*, [Validators.required]*/)];

    formsDisabled: boolean = false;
    formsGlobalError: string = '';

    private langueSub: any;

    constructor(private readonly apiService: IxellAPIService, private readonly translateService: TranslateService) { }

    ngOnInit() {
        if (this.folder.mode > 1) {
            this.selectedCountries.pop();
            this.selectedLanguages.pop();
            this.selectedFiles.pop();
            this.selectedFilenames.pop();
            this.chosenTitles.pop();

            this.selectedCountries[0] = this.selectedCountry;
            this.selectedLanguages[0] = this.selectedLanguage;
        }
    }

    ngOnDestroy() {
        if (this.langueSub != null) this.langueSub.unsubscribe();
    }

    onFileSelected(fileInput: HTMLInputElement, i: number) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function onFileSelected");
        ///*----------------------------------------------------------------------------------------------------*/console.log(fileInput.files);
        this.selectedFiles[i] = (fileInput.files.length > 0) ? fileInput.files[0] : null;
        this.selectedFilenames[i].setValue((fileInput.files.length > 0) ? fileInput.files[0].name : null);
        this.selectedFilenames[i].markAsTouched();
        this.chosenTitles[i].setValue((fileInput.files.length > 0) ? fileInput.files[0].name : "");
        this.chosenTitles[i].markAsTouched();
    }

    onFileReset(fileInput: HTMLInputElement) {
        fileInput.value = null;
        fileInput.dispatchEvent(new Event('change'));
    }

    getLanguage(locale: GroupedLocale, langId: number) {
        return locale.langues.find(l => l.idLangue == langId);
    }

    translateFolderPath(path: string, translateDict: { [key: string]: string }) {
        return path.split('\\').map(elem => translateDict[elem]).join('\\');
    }

    doClose() {
        this.close.emit();
    }

    doSave() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function doSave");

        this.formsGlobalError = '';
        this.reset.emit();

        let bad = false;
        let clearEnglish = false;

        // Check for bad form inputs
        for (let i = 0; i < this.selectedLanguages.length; i++) {
            ///*----------------------------------------------------------------------------------------------------*/console.log(this.selectedFilenames[i]);

            if (i == 1 && this.selectedFilenames[i].value != "") {
                if (this.selectedFilenames[i].invalid || this.chosenTitles[i].invalid) {
                    this.selectedFilenames[i].markAsTouched();
                    this.chosenTitles[i].markAsTouched();
                    bad = true;
                }
            } else {
                clearEnglish = true;
            }
        }

        ///*----------------------------------------------------------------------------------------------------*/console.log("bad", bad);

        if (bad)
            return;

        let data = this.selectedLanguages.map((_, i) => ({
            country: this.selectedCountries[i],
            language: this.selectedLanguages[i],
            title: this.chosenTitles[i].value,
            file: this.selectedFiles[i]
        }));

        ///*----------------------------------------------------------------------------------------------------*/console.log("data", data);
        let data2 = data.pop();
        ///*----------------------------------------------------------------------------------------------------*/console.log("data", data);
        ///*----------------------------------------------------------------------------------------------------*/console.log("data2", data2);

        this.save.emit({
            folder: this.folder,
            data: data,
            formStatusChanger: (state: boolean | string) => this.changeFormState(state)
        });
    }

    changeFormState(state: boolean | string) {
        if (typeof (state) === 'string') {
            this.formsGlobalError = state;
            this.changeFormState(false);
            return;
        }

        this.formsDisabled = state;

        for (const selectedFilename of this.selectedFilenames) {
            if (state)
                selectedFilename.disable();
            else
                selectedFilename.enable();
        }

        for (const chosenTitle of this.chosenTitles) {
            if (state)
                chosenTitle.disable();
            else
                chosenTitle.enable();
        }
    }
}
